import { render } from "./About.vue?vue&type=template&id=075b3420&scoped=true"
const script = {}
script.render = render
script.__scopeId = "data-v-075b3420"

export default script